import { Record } from 'immutable';

const UNIQUE_FAKE_ID = 'FAKEID';

type TypeRegion = {
    id: string,
    nom: string,
}

const RegionRecord = Record({
    id: '',
    nom: '',
});

class Region extends RegionRecord {

    get id(): string {
        return this.get('id')
    }
    get nom(): string {
        return this.get('nom')
    }
    constructor(props: Partial<TypeRegion> = {}) {
        super(({
            ...props,

        }));
    }

    setId(id: string): this {
        return this.set('id', id)
    }
    setNom(nom: string): this {
        return this.set('nom', nom)
    }

}

export default Region;